<template>
  <validation-observer ref="blog">
    <v-form v-if="form" @submit.prevent="save" ref="form">
      <v-row>
        <v-col>
          <validation-provider
            rules="required|max:255|min:3"
            name="title"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="form.title"
              outlined
              required
              label="Title"
              :error-messages="errors"
            ></v-text-field>
          </validation-provider>

          <validation-provider
            rules="required|max:255|min:3"
            name="subtitle"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="form.subtitle"
              required
              outlined
              label="Subtitle"
              :error-messages="errors"
            >
            </v-text-field>
          </validation-provider>

          <validation-provider
            rules="required"
            name="content"
            v-slot="{ errors }"
          >
            <quill-editor :error-messages="errors" v-model="form.content" />
          </validation-provider>

          <v-checkbox color="primary" v-model="form.publish" label="Publish?" />
        </v-col>

        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="cover"
          >
            <input hidden :value="blogCover" />
            <v-img
              class="mb-4"
              v-if="blogCover"
              :src="blogCover"
              :lazy-src="blogCover"
              size="100%"
            />
            <v-btn @click="addCover" color="primary">
              {{ blogCover ? 'Change' : 'Add' }} cover image
            </v-btn>
            <div
              v-if="errors.length"
              class="v-messages theme--light error--text mt-3 pl-3"
            >
              <div class="v-messages__wrapper">
                <div class="v-messages__message">
                  {{ errors[0] }}
                </div>
              </div>
            </div>
          </validation-provider>
        </v-col>
      </v-row>

      <v-btn
        :disabled="isLoading"
        :loading="isLoading"
        @click="save"
        color="primary"
        class="mt-4"
      >
        {{ saveText }}
      </v-btn>

      <!-- Image cropper component -->
      <image-cropper
        v-model="showImageUpload"
        :aspect-ratio="16 / 9"
        @change="imageChanged"
      />
    </v-form>
  </validation-observer>
</template>

<script>
import Blog from '@/models/Blog'
import ImageCropper from '@/components/modals/ImageCropper'
import QuillEditor from '@/components/QuillEditor'
import { cloneDeep } from 'lodash'

export default {
  components: {
    ImageCropper,
    QuillEditor
  },
  props: {
    isLoading: { type: Boolean, default: false },
    blog: {
      type: Blog,
      default() {
        return new Blog({
          title: '',
          subtitle: '',
          content: '',
          cover: null,
          publish: true
        })
      }
    },
    saveText: {
      type: String,
      default: 'Save blog'
    }
  },
  data() {
    return {
      form: null,
      showImageUpload: false,
      cover: null,
      errors: []
    }
  },
  mounted() {
    this.setForm(this.blog)
  },
  computed: {
    blogCover() {
      if (this.cover) {
        return this.cover
      } else if (this.blog.cover) {
        return this.blog.cover.url
      }
      return null
    }
  },
  methods: {
    setForm(blog) {
      if (blog) {
        this.form = cloneDeep(blog)
        this.form.publish = !!this.form.published_at
      }
    },
    setErrors(errors) {
      this.$refs.blog.setErrors(errors)
    },
    addCover() {
      this.showImageUpload = true
    },
    async save() {
      const isValid = await this.$refs.blog.validate()
      if (isValid) {
        this.$emit('save', {
          ...this.form,
          cover: this.cover ? this.form.cover : null
        })
      }
    },
    imageChanged(image) {
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
        this.cover = reader.result
        this.form.cover = image
      }
    }
  },
  watch: {
    blog(blog) {
      this.setForm(blog)
    }
  }
}
</script>
